import { ITodo } from '../entities/ITodo';
import { httpClient } from './helper/httpClient';

export interface ICreateTodoParams {
  title: string;
  description?: string;
  dueDate?: string;
  leadId?: string;
  eventId?: string;
}

export interface IUpdateTodoParams {
  title?: string;
  description?: string;
  done?: boolean;
  dueDate?: string;
  leadId?: string | null;
  eventId?: string | null;
}

export interface ITodoFilters {
  leadId?: string;
  eventId?: string;
  done?: boolean;
  dueDateFrom?: string;
  dueDateTo?: string;
}

class TodoService {
  private _baseURL = 'todos';

  create(data: ICreateTodoParams): Promise<ITodo> {
    return httpClient.post<null, ITodo>(this._baseURL, { ...data });
  }

  getAll(filters?: ITodoFilters): Promise<ITodo[]> {
    const params = new URLSearchParams();

    if (filters?.leadId) params.set('leadId', filters.leadId);
    if (filters?.eventId) params.set('eventId', filters.eventId);
    if (filters?.done !== undefined) params.set('done', String(filters.done));
    if (filters?.dueDateFrom) params.set('dueDateFrom', filters.dueDateFrom);
    if (filters?.dueDateTo) params.set('dueDateTo', filters.dueDateTo);

    const queryString = params.toString();
    const url = queryString ? `${this._baseURL}?${queryString}` : this._baseURL;

    return httpClient.get<null, ITodo[]>(url);
  }

  getById(id: string): Promise<ITodo> {
    return httpClient.get<null, ITodo>(`${this._baseURL}/${id}`);
  }

  update(id: string, data: IUpdateTodoParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, { ...data });
  }

  toggle(id: string): Promise<ITodo> {
    return httpClient.patch<null, ITodo>(`${this._baseURL}/${id}/toggle`, null);
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }
}

export default new TodoService();
